<script lang="ts">
    import lang from '../lang/language';
    import wishlist from '../store/wishlist';
    import type { ServiceType } from '../store/types';
    import { getBookNow } from '../helpers/common';
    export let service: any;
    export let className: string = 'first-button';
    export let style = '';
    export let bookingQuote;
    export let startTimeIndex;

    let wishlistIds = wishlist.ids;

    const like = (e) => {
        e.stopPropagation();
        wishlist.add(service, bookingQuote, startTimeIndex);
    };

    $: liked = $wishlistIds.includes(service.Id);
</script>

<button class={className} {style} on:click={like}>
    <span>{liked ? lang.remove_from_wishlist : getBookNow(service.Type)}</span>
</button>

<style>
    /*:global(.like-button) {*/
    /*    width: 40px;*/
    /*    height: 40px;*/
    /*    !*border-radius: 100%;*!*/
    /*    color: white;*/
    /*    cursor: pointer;*/
    /*    text-align: center;*/
    /*    !*padding: 10px 0px;*!*/
    /*    font-size: 20px;*/
    /*    !*background-color: rgba(0, 0, 0, 0.37);*!*/
    /*    !*transition: all .2s;*!*/
    /*    font-family: 'Myriad Pro Regular';*/
    /*}*/

    /*:global(.like-button:hover) {*/
    /*    background-color: black;*/
    /*    transition: all .2s;*/
    /*}*/

    /*:global(.like-button:active) > :global(i) {*/
    /*    font-size: 30px;*/
    /*    transition: all .1s;*/
    /*}*/

    /*:global(.like-button.liked) {*/
    /*    color: red;*/
    /*}*/
</style>
